import { useCallback, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  getGuestAccessCopy,
  rememberGuestBrowseIntent,
} from '../../utils/auth/guestBrowseIntent';

export default function useGuestAccessPrompt() {
  const navigate = useNavigate();
  const location = useLocation();
  const [prompt, setPrompt] = useState(null);

  const openPrompt = useCallback((intent, entityId = null) => {
    setPrompt({ intent, entityId });
  }, []);

  const closePrompt = useCallback(() => {
    setPrompt(null);
  }, []);

  const rememberAndGo = useCallback((path) => {
    rememberGuestBrowseIntent({
      pathname: location.pathname,
      search: location.search || '',
      intent: prompt?.intent || null,
      entityId: prompt?.entityId || null,
    });
    navigate(path, { state: { from: location } });
  }, [location, navigate, prompt]);

  const handleLogin = useCallback(() => {
    rememberAndGo('/login');
  }, [rememberAndGo]);

  const handleSignUp = useCallback(() => {
    const { userType } = getGuestAccessCopy(prompt?.intent);
    rememberAndGo(`/sign-up?userType=${userType}`);
  }, [prompt, rememberAndGo]);

  return {
    prompt,
    openPrompt,
    closePrompt,
    handleLogin,
    handleSignUp,
  };
}
